import React, { useState } from 'react'
import { Button} from 'react-bootstrap'
import { Plus, Pencil } from 'react-bootstrap-icons'
import ReflectionsList from '../list'
import userCurrentUser from '../../../hooks/use-current-user'
import { get } from 'lodash'

const Reflections = ({
    userId,
}) => {
    const { currentUser } = userCurrentUser()
    const editable = userId === get(currentUser, 'id')
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                <div style={{
                    flexGrow: '1',
                    fontSize: '1.1em',
                    fontWeight: '700'
                }}>
                    MONTHLY REFLECTIONS
                </div>
            </div>
            <div><ReflectionsList userId={userId} editable={editable} /></div>
        </div>
    )
}

export default Reflections